import { createUserWithEmailAndPassword } from 'firebase/auth';
import { createAPerson } from '../Database/CreateAPerson';
import { auth } from '../firebase';

export const signUp: (
    email: string,
    firstName: string,
    lastName: string,
    password: string,
) => Promise<boolean> = async (email, firstName, lastName, password) => {
    try {
        await createUserWithEmailAndPassword(auth, email, password);
        await createAPerson(firstName, lastName, email);
        return true;
    } catch (err) {
        throw err;
    }
};
